import React from "react";
import TabPage, { TabItemProps } from "../../components/dynamic/Tab";
import ClientTabs from "./components/ClientTabs";
import ProviderTabs from "./components/ProviderTabs";
import AppointmentReportsTab from "./components/AppointmentReportsTab";
import checkPermission from "../../utils/permission";

export default function AppointmentsPage() {
  const canAddAppointment = checkPermission("appointment_view");
  const canManageAppointments = checkPermission("appointment_manage");
  const canViewReports = checkPermission("appointment_report_list");

  const tabs: TabItemProps[] = [];
  if (canAddAppointment) {
    tabs.push({
      type: "custom",
      title: "Randevu Al",
      path: "client",
      tabId: "client",
      customComponent: <ClientTabs />,
    });
  }
  if (canManageAppointments) {
    tabs.push({
      type: "custom",
      title: "Randevu Yönetimi",
      path: "provider",
      tabId: "provider",
      customComponent: <ProviderTabs />,
    });
  }
  if (canViewReports) {
    tabs.push({
      type: "custom",
      title: "Raporlar",
      path: "reports",
      tabId: "reports",
      customComponent: <AppointmentReportsTab />,
    });
  }

  if (tabs.length === 0) {
    return (
      <div className="h-[88vh] bg-gray-50 overflow-hidden flex">
        <div className="flex-1 min-w-0 flex items-center justify-center">
          <div className="text-center text-gray-600">Bu alana erişim yetkiniz bulunmuyor.</div>
        </div>
      </div>
    );
  }

  return <TabPage title="Randevular" tabs={tabs} />;
}
